module.exports = __webpack_public_path__ + "img/rocket.34801d0a.png";